import React from 'react';

const ProjectAddPage = React.lazy(() => import('pages/Project/ProjectAddPage'));
const ProjectPage = React.lazy(() => import('pages/Project/ProjectPage'));

const departmentRoute = [
  {
    path: '/project',
    exact: true,
    name: 'Danh sách dự án',
    function: 'MD_DEPARTMENT_VIEW',
    component: ProjectPage,
  },
  {
    path: '/project/add',
    exact: true,
    name: 'Thêm mới dự án',
    function: 'MD_DEPARTMENT_ADD',
    component: ProjectAddPage,
  },
  {
    path: '/project/detail/:department_id',
    exact: true,
    name: 'Chi tiết dự án',
    function: 'MD_DEPARTMENT_VIEW',
    component: ProjectAddPage,
  },
  {
    path: '/project/edit/:department_id',
    exact: true,
    name: 'Chỉnh sửa dự án',
    function: 'MD_DEPARTMENT_EDIT',
    component: ProjectAddPage,
  },
];

export default departmentRoute;
